import React, { Component } from "react";
import { Helmet } from 'react-helmet';
import axios from 'axios';
import GoogleMapComponent from "./track-booking";
import { TERMINAL_STATUSES } from "../../constants/statuses";
import { format } from 'date-fns-tz';
import { Link } from 'react-router-dom';
import Header from "../layout/header";
import Footer from "../layout/footer";
import { BookingStatusStepper } from "../elements/premium";

class BookingDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bookingDetails: null,
      selectedMarker: null,
      isLoaded: false,
      paymentMessage: '',
      photos: [],
      // Review section state
      hasSubmittedReview: false,
      selectedRating: null,
      feedbackText: '',
      showFeedbackForm: false,
      isSubmittingReview: false,
      reviewMessage: ''
    };
    this.handlePay = this.handlePay.bind(this);
    this.handleCallMechanic = this.handleCallMechanic.bind(this);
    this.handleRatingClick = this.handleRatingClick.bind(this);
    this.handleFeedbackSubmit = this.handleFeedbackSubmit.bind(this);
  }

  componentDidMount() {
    this.loadScriptGoogleMaps();
    this.fetchBookingDetails();
    this.fetchBookingPhotos();
  }

  loadScriptGoogleMaps() {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      this.setState({ isLoaded: true });
    };

    document.head.appendChild(script);
  }

  async fetchBookingDetails() {
    try {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const bookingId = urlSearchParams.get("booking_id");
      const actualBookingId = urlSearchParams.get("actual_booking_id");
      let bookingDetails;

      if (bookingId) {
        bookingDetails = await axios.get(`https://ridenrepair.com/api/get_booking_via_booking_id?booking_id=${bookingId}`);
        this.setState({ bookingDetails: bookingDetails.data }, () => {
          // Fetch customer rating after booking details are loaded
          this.fetchCustomerRating();
        });
      } else if (actualBookingId) {
        bookingDetails = await axios.get(`https://ridenrepair.com/api/get_booking_via_actual_booking_id?booking_id=${actualBookingId}`);
        this.setState({ bookingDetails: bookingDetails.data }, () => {
          // Fetch customer rating after booking details are loaded
          this.fetchCustomerRating();
        });
      } else {
        
      }
    } catch (error) {
      
    }
  }

  async fetchBookingPhotos() {
    try {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const bookingId = urlSearchParams.get("actual_booking_id");

      const response = await axios.get(`https://ridenrepair.com/api/get_booking_photos?booking_id=${bookingId}`);

      if (response.data.success) {
        this.setState({ photos: response.data.photos });
      } else {
        
      }
    } catch (error) {
      
    }
  }

  onSuccessfulPayment = (booking_id, email, amount) => {
    const params = {
      booking_id: booking_id,
      email: email,
      paid_amount: amount,
      order_status: 'COMPLETED'
    }

    try {
      axios.post("https://ridenrepair.com/api/update_booking_paid_amount", params, { headers: { 'Content-Type': 'application/json' } });
    } catch (error) {
      
    }

    try {
      axios.post("https://ridenrepair.com/api/update_booking_status", params, { headers: { 'Content-Type': 'application/json' } });
    } catch (error) {
      
    }

    this.setState({ paymentMessage: 'Paid Successfully' });
	}

  loadScript = (src) => {
		return new Promise((resolve) => {
			const script = document.createElement("script");
			script.src = src;
			script.onload = () => {
				resolve(true);
			};
			script.onerror = () => {
				resolve(false);
			};
			document.body.appendChild(script);
		});
	}

  async handleCallMechanic() {
    const { bookingDetails } = this.state;
    if (!bookingDetails) return;

    try {
      const payload = {
        mechanic_number: bookingDetails.mechanic_number,
        booking_id:      bookingDetails.booking_id,
        customer_phone:  bookingDetails.phone
      };

      await axios.post(
        "https://www.ridenrepair.com/api/sip_connect_customer_to_mechanic",
        payload,
        { headers: { 'Content-Type': 'application/json' } }
      );

      // Call connected successfully
      // Can add user notification here if needed
    } catch (err) {
      // console.log("Failed to connect call:", err);
      // optionally show an error message to the user
    }
  }

  async fetchCustomerRating() {
    const { bookingDetails } = this.state;
    if (!bookingDetails) return;

    try {
      const response = await axios.post(
        "https://ridenrepair.com/api/get_customer_rating",
        {
          booking_id: bookingDetails.booking_id,
          email: bookingDetails.email
        },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (response.data && response.data.customer_rating !== null && response.data.customer_rating !== undefined) {
        this.setState({
          hasSubmittedReview: true,
          selectedRating: response.data.customer_rating
        });
      }
    } catch (error) {
      // Rating not found or error - user hasn't submitted review yet
    }
  }

  async handleRatingClick(rating) {
    const { hasSubmittedReview, bookingDetails } = this.state;
    
    // Prevent rating change if already submitted
    if (hasSubmittedReview) {
      return;
    }

    this.setState({ isSubmittingReview: true });

    try {
      // Immediately save the rating to make it permanent
      await axios.post(
        "https://ridenrepair.com/api/update_customer_feedback",
        {
          booking_id: bookingDetails.booking_id,
          email: bookingDetails.email,
          customer_rating: rating,
          customer_feedback: ''
        },
        { headers: { 'Content-Type': 'application/json' } }
      );

      // Update state to lock in the rating and show appropriate UI
      this.setState({
        selectedRating: rating,
        hasSubmittedReview: true,
        showFeedbackForm: true,
        isSubmittingReview: false
      });
    } catch (error) {
      this.setState({
        isSubmittingReview: false,
        reviewMessage: 'Failed to submit rating. Please try again.'
      });
    }
  }

  async handleFeedbackSubmit() {
    const { bookingDetails, selectedRating, feedbackText } = this.state;

    if (!feedbackText.trim()) {
      return;
    }

    this.setState({ isSubmittingReview: true });

    try {
      await axios.post(
        "https://ridenrepair.com/api/update_customer_feedback",
        {
          booking_id: bookingDetails.booking_id,
          email: bookingDetails.email,
          customer_rating: selectedRating,
          customer_feedback: feedbackText
        },
        { headers: { 'Content-Type': 'application/json' } }
      );

      this.setState({
        isSubmittingReview: false,
        reviewMessage: 'Thank you for your valuable feedback!',
        feedbackText: ''
      });
    } catch (error) {
      this.setState({
        isSubmittingReview: false,
        reviewMessage: 'Failed to submit feedback. Please try again.'
      });
    }
  }

  async handlePay (payAmount) {
    try {
      const { booking_id, email, name, phone } = this.state.bookingDetails;
      const res = await this.loadScript(
        "https://checkout.razorpay.com/v1/checkout.js"
      );

      if (!res) {
        alert("Razorpay SDK failed to load. Are you online?");
        return;
      }
    
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ amount: payAmount * 100, currency: 'INR' })
      };

      const data = await fetch('https://ridenrepair.com/api/razorpay', requestOptions).then(
        (response) => response.json()
      )

      const options = {
        key: 'rzp_live_v9Y9ZhDUWFgjNI',
        // key: 'rzp_live_JiAxnDUo1qXebr', // Enter the Key ID generated from the Dashboard
        // key: 'rzp_test_K9AJpedBWJr6ah',
        amount: payAmount,
        currency: data.currency,
        name: 'Ride N Repair',
        description: 'Service Transaction',
          image: 'https://ridenrepair.com/api/logo.png',
          order_id: data.id,
          handler: (response) => {this.onSuccessfulPayment(booking_id, email, parseFloat(data.amount) / 100); },
          prefill: {
            name: name || 'User',
            email: email,
            contact: phone,
          },
          notes: {
            booking_id: booking_id,
          },
          theme: {
            color: "#61dafb",
          },
      };
      
      if (typeof window !== 'undefined') {
        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
      }
    } catch (error) {
      
    }
  }

  render() {
    const { bookingDetails, isLoaded } = this.state;
    const indiaTimezone = 'Asia/Kolkata';
    const dateFormat = 'yyyy-MM-dd';
    const formattedDate = format(new Date(), dateFormat, { timeZone: indiaTimezone });

    if (!isLoaded) {
      return (
        <div className="booking-details-wrapper">
          <Header user={this.props.user} setUser={this.props.setUser} isMobileApp={this.props.isMobileApp} />
          <div className="container" style={{ padding: '80px 20px', textAlign: 'center' }}>
            <div className="loading-spinner" style={{ fontSize: '1.2rem', color: '#f42222' }}>
              <i className="fa fa-spinner fa-spin" style={{ marginRight: '10px' }}></i>
              Loading your booking details...
            </div>
          </div>
          <Footer />
        </div>
      );
    }

    if (!bookingDetails) {
      return (
        <div className="booking-details-wrapper">
          <Header user={this.props.user} setUser={this.props.setUser} isMobileApp={this.props.isMobileApp} />
          <div className="container" style={{ padding: '80px 20px', textAlign: 'center' }}>
            <h2 style={{ color: '#333', marginBottom: '20px' }}>No booking details found</h2>
            <p style={{ color: '#878e9c', marginBottom: '30px' }}>We couldn't find the booking you're looking for.</p>
            <Link to="/" className="btn-primary-custom" style={{ display: 'inline-block', padding: '15px 30px', textDecoration: 'none' }}>
              Return to Homepage
            </Link>
          </div>
          <Footer />
        </div>
      );
    }

    // Check if booking is completed and show review section
    const isCompletedBooking = bookingDetails.order_status === 'COMPLETED' || bookingDetails.order_status === 'CASH TAKEN';
    
    // For completed bookings, show review page instead of "no further action" message
    if (TERMINAL_STATUSES.includes(bookingDetails.order_status) && !isCompletedBooking) {
      return (
        <div className="booking-details-wrapper">
          <Header user={this.props.user} setUser={this.props.setUser} isMobileApp={this.props.isMobileApp} />
          <div className="booking-details-header">
            <div className="container">
              <div className="booking-header-content">
                <h1>Booking Completed</h1>
                <p className="booking-id-badge">
                  Status: <strong>{bookingDetails.order_status}</strong>
                </p>
              </div>
            </div>
          </div>
          <div className="container" style={{ padding: '40px 20px', textAlign: 'center' }}>
            <div className="booking-details-card">
              <p style={{ fontSize: '1.1rem', color: '#666' }}>This booking doesn't require further action.</p>
              <Link to="/booking-history" className="btn-primary-custom" style={{ marginTop: '20px', display: 'inline-block', textDecoration: 'none' }}>
                View All Bookings
              </Link>
            </div>
          </div>
          <Footer />
        </div>
      );
    }

    // For past bookings that aren't completed, also show the "no further action" message
    if (bookingDetails.date_of_service < formattedDate && !isCompletedBooking) {
      return (
        <div className="booking-details-wrapper">
          <Header user={this.props.user} setUser={this.props.setUser} isMobileApp={this.props.isMobileApp} />
          <div className="booking-details-header">
            <div className="container">
              <div className="booking-header-content">
                <h1>Booking Details</h1>
                <p className="booking-id-badge">
                  ID: <strong>{bookingDetails.booking_id}</strong>
                </p>
              </div>
            </div>
          </div>
          <div className="container" style={{ padding: '40px 20px', textAlign: 'center' }}>
            <div className="booking-details-card">
              <p style={{ fontSize: '1.1rem', color: '#666' }}>This booking is now closed and doesn't require further action.</p>
              <Link to="/booking-history" className="btn-primary-custom" style={{ marginTop: '20px', display: 'inline-block', textDecoration: 'none' }}>
                View All Bookings
              </Link>
            </div>
          </div>
          <Footer />
        </div>
      );
    }

    const dateOfService = new Date(bookingDetails.date_of_service);
    const formatServiceTime = (t) => {
      if (!t) return '';
      const [hStr, mStr] = String(t).split(':');
      let h = parseInt(hStr, 10);
      if (isNaN(h)) return String(t);
      const m = (mStr || '00').padStart(2, '0');
      const ampm = h >= 12 ? 'PM' : 'AM';
      h = h % 12 || 12;
      return `${h}:${m} ${ampm}`;
    };
    const timeOfService = formatServiceTime(bookingDetails.time_of_service);

    return (
      <div className="booking-details-wrapper">
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
        <Header user={this.props.user} setUser={this.props.setUser} isMobileApp={this.props.isMobileApp} />

        {/* Page Header */}
        <div className="booking-details-header">
          <div className="container">
            <div className="booking-header-content">
              <h1>
                {isCompletedBooking ? 'Service Completed' : 'Track Your Service'}
              </h1>
              <p className="booking-id-badge">
                Booking ID: <strong>{bookingDetails.booking_id}</strong>
              </p>
            </div>
          </div>
        </div>

        <div className="container">
          {/* Unified post-booking journey (additive, read-only — same surface
              the existing tracking-link SMS lands on across all channels). */}
          <div className="rr-thankyou-stepper" style={{ marginTop: 24 }}>
            <BookingStatusStepper bookingId={bookingDetails.booking_id} />
          </div>

          {/* Live Tracking Map */}
          {!isCompletedBooking && (
            <div className="tracking-map-section">
              <GoogleMapComponent
                paths={[
                  [
                    { lat: parseFloat(bookingDetails.latitude), lng: parseFloat(bookingDetails.longitude) },
                    { lat: parseFloat(bookingDetails.mechanicLatitude), lng: parseFloat(bookingDetails.mechanicLongitude) },
                  ],
                ]}
                mapCenter={{ latitude: parseFloat(bookingDetails.latitude), longitude: parseFloat(bookingDetails.longitude) }}
                initialZoom={14}
                mechanicData={{
                  latitude: parseFloat(bookingDetails.mechanicLatitude),
                  longitude: parseFloat(bookingDetails.mechanicLongitude),
                }}
                customerData={{
                  latitude: parseFloat(bookingDetails.latitude),
                  longitude: parseFloat(bookingDetails.longitude),
                  booking_id: bookingDetails.booking_id,
                }}
              />
            </div>
          )}

          {/* Booking Details Card */}
          <div className="booking-details-card">
            <div className="card-header">
              <h2>Booking Information</h2>
            </div>

            <div className="booking-info-grid">
              <div className="info-item">
                <div className="info-icon">
                  <i className="fa fa-motorcycle"></i>
                </div>
                <div className="info-content">
                  <div className="info-label">Vehicle</div>
                  <div className="info-value">{bookingDetails.vehicle_name}</div>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <i className="fa fa-calendar"></i>
                </div>
                <div className="info-content">
                  <div className="info-label">Date of Service</div>
                  <div className="info-value">{dateOfService.toDateString()}</div>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <i className="fa fa-clock-o"></i>
                </div>
                <div className="info-content">
                  <div className="info-label">Time of Service</div>
                  <div className="info-value">{timeOfService}</div>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <i className="fa fa-wrench"></i>
                </div>
                <div className="info-content">
                  <div className="info-label">Service Type</div>
                  <div className="info-value">{bookingDetails.service_type}</div>
                </div>
              </div>
            </div>

            {/* Payment Section */}
            {bookingDetails.final_payment_amount ? (
              <div className="payment-section">
                <h3 style={{ fontFamily: 'Roboto Condensed, sans-serif', fontSize: '1.4rem', fontWeight: '700', marginBottom: '20px', color: '#000' }}>
                  Payment Details
                </h3>
                <table className="payment-table">
                  <thead>
                    <tr>
                      <th>Description</th>
                      <th style={{ textAlign: 'right' }}>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bookingDetails.charges_desc.split(',').map((desc, index) => (
                      <tr key={index}>
                        <td>{desc}</td>
                        <td>₹ {bookingDetails.amount_details.split(',')[index]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="payment-total">
                  <span className="total-label">Total Amount:</span>
                  <span className="total-amount">₹ {bookingDetails.final_payment_amount}</span>
                </div>
              </div>
            ) : (
              <div className="payment-section">
                <div className="payment-total">
                  <span className="total-label">Estimated Amount:</span>
                  <span className="total-amount">₹ {bookingDetails.total_amount}</span>
                </div>
              </div>
            )}

            {/* Action Buttons */}
            <div className="action-buttons">
              {bookingDetails.final_payment_amount && !this.state.paymentMessage && (
                <button 
                  className="btn-primary-custom"
                  onClick={() => this.handlePay(parseFloat(bookingDetails.final_payment_amount))}
                >
                  <i className="fa fa-credit-card" style={{ marginRight: '8px' }}></i>
                  Pay ₹ {bookingDetails.final_payment_amount}
                </button>
              )}
              
              {!isCompletedBooking && (
                <button
                  className="btn-secondary-custom"
                  onClick={this.handleCallMechanic}
                >
                  <i className="fa fa-phone" style={{ marginRight: '8px' }}></i>
                  Call Mechanic
                </button>
              )}

              <Link
                className="btn-secondary-custom"
                to={{ pathname: '/complaint', state: { bookingId: bookingDetails.booking_id, phone: bookingDetails.phone, name: bookingDetails.first_name } }}
                style={{ textDecoration: 'none' }}
              >
                <i className="fa fa-exclamation-circle" style={{ marginRight: '8px' }}></i>
                Raise a Complaint
              </Link>
            </div>

            {this.state.paymentMessage && (
              <div className="payment-message">
                {this.state.paymentMessage}
              </div>
            )}
          </div>

          {/* Photos Gallery */}
          {this.state.photos.length > 0 && (
            <div className="photos-gallery-section">
              <h2>Service Photos</h2>
              <div className="photo-gallery">
                {this.state.photos.map((photo, index) => (
                  <img 
                    key={index} 
                    src={photo} 
                    alt={`Service ${index + 1}`}
                    loading="lazy"
                  />
                ))}
              </div>
            </div>
          )}

          {/* Customer Review Section - Only show for completed bookings */}
          {isCompletedBooking && (
            <div className="customer-review-section">
              <div className="section-header">
                <h2>Share Your Experience</h2>
                <p className="section-subtitle">Your feedback helps us serve you better</p>
              </div>

              {this.state.hasSubmittedReview && !this.state.showFeedbackForm ? (
                <div className="review-submitted">
                  <div className="success-icon">✓</div>
                  <h3>Thank You for Your Feedback!</h3>
                  <p>Your {this.state.selectedRating}-star rating has been recorded.</p>
                  <div className="rating-display">
                    {[...Array(this.state.selectedRating)].map((_, i) => (
                      <span key={i}>★</span>
                    ))}
                  </div>
                </div>
              ) : (
                <>
                  {!this.state.hasSubmittedReview ? (
                    <div className="star-rating-container">
                      <p className="rating-prompt">How was your experience with Ride N Repair?</p>
                      <div className="stars-wrapper">
                        {[1, 2, 3, 4, 5].map((star) => (
                          <button
                            key={star}
                            className="star-button"
                            onClick={() => this.handleRatingClick(star)}
                            disabled={this.state.isSubmittingReview}
                            aria-label={`Rate ${star} stars`}
                          >
                            ★
                          </button>
                        ))}
                      </div>
                      {this.state.isSubmittingReview && (
                        <p className="rating-loading">
                          <i className="fa fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
                          Submitting your rating...
                        </p>
                      )}
                    </div>
                  ) : (
                    <div className="rating-feedback-container">
                      {/* High Rating (4-5 stars) */}
                      {this.state.selectedRating >= 4 ? (
                        <div>
                          <div className="rating-message high-rating">
                            <div className="message-icon">
                              {this.state.selectedRating === 5 ? '🎉' : '😊'}
                            </div>
                            <h3>
                              {this.state.selectedRating === 5 
                                ? "We're thrilled you loved our service!" 
                                : "We're glad you enjoyed our service!"}
                            </h3>
                          </div>

                          {!this.state.reviewMessage && (
                            <div className="feedback-form">
                              <label className="feedback-label">
                                {this.state.selectedRating === 4 
                                  ? 'What could we do better?' 
                                  : 'Tell us what you loved (optional)'}
                              </label>
                              <textarea
                                className="feedback-textarea"
                                value={this.state.feedbackText}
                                onChange={(e) => this.setState({ feedbackText: e.target.value })}
                                placeholder={this.state.selectedRating === 4 
                                  ? "Your suggestions help us improve..." 
                                  : "Share your experience..."}
                              />
                              <button
                                className="submit-button"
                                onClick={this.handleFeedbackSubmit}
                                disabled={this.state.isSubmittingReview || !this.state.feedbackText.trim()}
                              >
                                {this.state.isSubmittingReview ? 'Submitting...' : 'Submit Feedback'}
                              </button>
                            </div>
                          )}

                          {this.state.reviewMessage && (
                            <div className="feedback-form">
                              <div className="feedback-message">{this.state.reviewMessage}</div>
                            </div>
                          )}

                          <div className="google-review-cta">
                            <h4>Share Your Experience Publicly</h4>
                            <a
                              href="https://g.co/kgs/nE18R2"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="google-button"
                            >
                              <span>Review on Google Maps</span>
                            </a>
                          </div>
                        </div>
                      ) : (
                        /* Low Rating (1-3 stars) */
                        <div>
                          <div className="rating-message low-rating">
                            <div className="message-icon">😞</div>
                            <h3>We're sorry to hear that</h3>
                            <p style={{ fontSize: '1.1rem', color: '#666', marginTop: '10px' }}>
                              Your feedback helps us improve our service
                            </p>
                          </div>

                          {!this.state.reviewMessage && (
                            <div className="feedback-form">
                              <label className="feedback-label">
                                Please tell us what we can do better:
                              </label>
                              <textarea
                                className="feedback-textarea"
                                value={this.state.feedbackText}
                                onChange={(e) => this.setState({ feedbackText: e.target.value })}
                                placeholder="Your feedback is valuable to us..."
                              />
                              <button
                                className="submit-button"
                                onClick={this.handleFeedbackSubmit}
                                disabled={this.state.isSubmittingReview || !this.state.feedbackText.trim()}
                              >
                                {this.state.isSubmittingReview ? 'Submitting...' : 'Submit Feedback'}
                              </button>
                            </div>
                          )}

                          {this.state.reviewMessage && (
                            <div className="feedback-form">
                              <div className="feedback-message">{this.state.reviewMessage}</div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </div>

        <Footer />
      </div>
    );
  }
}

export default BookingDetails;
